import { RRIBaseModel } from '../base-model.interface';
import { RRIPagination } from '../base-pagination.interface';

export interface RRITableData<T extends RRIBaseModel> {
  results: T[];
  pagination: RRIPagination;
}
